import React from "react";

import { CESAR_LOYALTY } from "@constants/index";

import FidelitySynapsy from "../../FidelitySynapsy";
import FidelityZerosix from "../../FidelityZerosix";

import { FormStateApi } from "../types";
import FidelityAuresKonnectWrapper from "../../FidelityAuresKonnectWrapper";

type Props = {
    state: FormStateApi;
    fidelityChoiceIndex: number;
    oneShop: boolean;
    isConsult: boolean;
    isExist: boolean;
    isFidelityNumberInValid: boolean;
    dataFidelity: any;
    setIsEdited: (v: boolean) => void;
};

export default function LoyaltyVariantSection({
    state,
    fidelityChoiceIndex,
    oneShop,
    isConsult,
    isExist,
    isFidelityNumberInValid,
    dataFidelity,
    setIsEdited,
}: Props) {
    const { values, flags, errors, setValue, setFlag, setError } = state;

    if (fidelityChoiceIndex === CESAR_LOYALTY) {
        return (
            <FidelityAuresKonnectWrapper
                numberFidelityPoints={values.numberFidelityPoints}
                setNumberFidelityPoints={(v: string) =>
                    setValue("numberFidelityPoints", v)
                }
                moneyCorrespondence={values.moneyCorrespondence}
                setMoneyCorrespondence={(v: string) =>
                    setValue("moneyCorrespondence", v)
                }
                sortedVisibility={values.sortedVisibility}
                setSortedVisibility={(v: any) =>
                    setValue("sortedVisibility", v)
                }
                setIsEdited={setIsEdited}
                dataFidelity={dataFidelity}
                auresKonnectGroup={values.auresKonnectGroup}
                setAuresKonnectGroup={(v: string) =>
                    setValue("auresKonnectGroup", v)
                }
                inputGroup={errors.group}
                setInputGroup={(v: boolean) => setError("group", v)}
                isCentralizationActive={flags.isCentralizationActive}
                setIsCentralizationActive={(v: boolean) =>
                    setFlag("isCentralizationActive", v)
                }
                isVisibiliteActive={flags.isVisibiliteActive}
                setIsVisibiliteActive={(v: boolean) =>
                    setFlag("isVisibiliteActive", v)
                }
                setChoiceFidelity={(v: string) => setValue("choiceFidelity", v)}
                choiceFidelity={values.choiceFidelity}
                designation={values.designation}
                setDesignation={(v: string) => setValue("designation", v)}
                isExist={isExist}
                isFidelityNumberInValid={isFidelityNumberInValid}
                inputNumberFidelityPoints={errors.numberFidelityPoints}
                setInputNumberFidelityPoints={(v: boolean) =>
                    setError("numberFidelityPoints", v)
                }
                isTest={false}
                isConsult={isConsult}
            />
        );
    }

    if (fidelityChoiceIndex === 2 && oneShop) {
        return (
            <FidelitySynapsy
                password={values.password}
                setPassword={(v: string) => setValue("password", v)}
                login={values.login}
                setLogin={(v: string) => setValue("login", v)}
                inputLogin={errors.login}
                setInputLogin={(v: boolean) => setError("login", v)}
                inputPassword={errors.password}
                setInputPassword={(v: boolean) => setError("password", v)}
                setIsEdited={setIsEdited}
                isConsult={isConsult}
            />
        );
    }

    if (fidelityChoiceIndex === 3 && oneShop) {
        return (
            <FidelityZerosix
                password={values.password}
                setPassword={(v: string) => setValue("password", v)}
                user={values.user}
                setUser={(v: string) => setValue("user", v)}
                inputUser={errors.user}
                setInputUser={(v: boolean) => setError("user", v)}
                inputPassword={errors.password}
                setInputPassword={(v: boolean) => setError("password", v)}
                setIsEdited={setIsEdited}
                dashboardLink={values.dashboardLink}
                setDashboardLink={(v: string) => setValue("dashboardLink", v)}
                apiKey={values.apiKey}
                setApiKey={(v: string) => setValue("apiKey", v)}
                inputDashboardLink={errors.dashboardLink}
                inputApiKey={errors.apiKey}
                setInputDashboardLink={(v: boolean) =>
                    setError("dashboardLink", v)
                }
                setInputApiKey={(v: boolean) => setError("apiKey", v)}
                isConsult={isConsult}
            />
        );
    }

    return null;
}
